import React from "react";

import { Icon, WrappingIconProps } from "../Icon";

export const StagedIcon = (props: WrappingIconProps) => {
  return (
    <Icon {...props}>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
      >
        <g clip-path="url(#clip0_890_18878)">
          <path
            d="M12 4L4 8L12 12L20 8L12 4Z"
            stroke={props.stroke}
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M4 12L12 16L20 12"
            stroke={props.stroke}
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M4 16L12 20L20 16"
            stroke={props.stroke}
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </g>
        <defs>
          <clipPath id="clip0_890_18878">
            <rect width="24" height="24" fill="white" />
          </clipPath>
        </defs>
      </svg>
    </Icon>
  );
};
